export default __webpack_public_path__ + "static/assets/med_capsule_V_tran_01_m_mask.e1dcac85.png";